import type { ReactElement } from 'react'
import { Fragment } from 'react'
import {
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  Skeleton,
} from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

const RowSkeleton = ({ length = 5 }): ReactElement => (
  <Tr>
    {Array.from({ length }).map(() => (
      <Td>
        <Skeleton height="20px" width="100%" />
      </Td>
    ))}
  </Tr>
)

const FolderListLoader = (): ReactElement | null => {
  const { t } = useTranslation()
  return (
    <Fragment>
      <Text fontWeight="semibold" color="appSlate">
        {t('folders', 'Folders')}
      </Text>
      <Table marginTop="2rem">
        <Thead bgColor="appPaleGreyTwo">
          <Tr>
            <Th width="4.1em" />
            <Th width="35em">{t('name', 'Name')}</Th>
            <Th width="7.85em">{t('last_modified', 'last_modified')}</Th>
          </Tr>
        </Thead>
        <Tbody>
          <RowSkeleton length={3} />
          <RowSkeleton length={3} />
          <RowSkeleton length={3} />
        </Tbody>
      </Table>
    </Fragment>
  )
}

export default FolderListLoader
